import Slide from './Slide';
import UserInfo from './UserInfo';
import QuickMenu from './QuickMenu';
import Banner from './Banner';
import { useLayoutEffect } from 'react';
import { useAppDispatch } from 'src/AppContext';

export default function Home(): JSX.Element {
  const dispatch = useAppDispatch();

  useLayoutEffect(() => {
    return () => {
      dispatch({ type: 'RESET_GNB_LEFT' });
      dispatch({ type: 'RESET_GNB_RIGHT' });
    };
  }, []);

  return (
    <div>
      <div className="w-full relative container" style={{ height: '21.25rem' }}>
        <div className="absolute top-0 left-0 w-full" style={{ height: '21.25rem' }}>
          <Slide />
        </div>
      </div>
      <div className="container mb-10">
        <section className="mt-9">
          <UserInfo />
        </section>
        <section className="mt-3 flex justify-center">
          <QuickMenu />
        </section>
        <section className="mt-10">
          <Banner />
        </section>
      </div>
    </div>
  );
}
